<div class="loader loader-lg loader-alignment" *ngIf="isLoading" role="status">
  <div id="loader1" class="loader-ring"></div>
  <label for="loader1">Loading data</label>
</div>